<div class="h-100 d-flex flex-column align-items-center justify-content-center">
    <div class="fade-in">
        <img width="300" src="../../../assets/images/logo-2.png" alt=""/>
    </div>
    
    <br>
    <div class="tagline">
        <p>Automate Your Engineering</p>
    </div>
    <br>
    <div class="message">
        Access Denied ...
    </div>
    <div class="sub-message">You do not have enough privilege to access this resource.</div>
    <br>
    <dx-button
        text="Go Home"
        type="default"
        [routerLink]="['/home']">
    </dx-button>
</div>